import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, vModelText as _vModelText, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3964e896"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "AdminMembers" }
const _hoisted_2 = { id: "showmembers" }
const _hoisted_3 = { class: "display-2 adminHeadline" }
const _hoisted_4 = { class: "tabHeight" }
const _hoisted_5 = { class: "row align--center justify--space-between" }
const _hoisted_6 = { class: "md1 flex" }
const _hoisted_7 = {
  class: "md3 flex",
  style: {"display":"flex"}
}
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_9 = { class: "md2 flex" }
const _hoisted_10 = { class: "md2 flex" }
const _hoisted_11 = { class: "md2 flex" }
const _hoisted_12 = { class: "row justify--center mb-4" }
const _hoisted_13 = { class: "flex" }
const _hoisted_14 = { class: "row justify--center mb-4" }
const _hoisted_15 = { class: "flex" }
const _hoisted_16 = { class: "row justify--center mb-4" }
const _hoisted_17 = { class: "flex" }
const _hoisted_18 = { class: "justify--center row mb-4" }
const _hoisted_19 = { class: "flex" }
const _hoisted_20 = { class: "row justify--center mb-4" }
const _hoisted_21 = { class: "flex" }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("Eksporter")
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "center" }, [
      /*#__PURE__*/_createElementVNode("i", null, [
        /*#__PURE__*/_createTextVNode("* Advarsel eksporter af alle medlemmer fra alle"),
        /*#__PURE__*/_createElementVNode("br"),
        /*#__PURE__*/_createTextVNode(" klubber kan tage et stykke tid")
      ])
    ])
  ])
], -1))
const _hoisted_24 = { class: "md2 flex" }
const _hoisted_25 = /*#__PURE__*/_createTextVNode("Opdater medlemsrettigheder")
const _hoisted_26 = { class: "row align--center justify--start mt-4" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md1 ml-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Kolonner:")
], -1))
const _hoisted_28 = {
  class: "flex md10",
  style: {"display":"flex"}
}
const _hoisted_29 = { key: 0 }
const _hoisted_30 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_31 = {
  class: "va-table va-table--striped membersTable",
  style: {"width":"100%"}
}
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "center",
  hidden: ""
}, "ID", -1))
const _hoisted_33 = { class: "center" }
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "Handlinger", -1))
const _hoisted_35 = ["id"]
const _hoisted_36 = ["id"]
const _hoisted_37 = ["id"]
const _hoisted_38 = ["id"]
const _hoisted_39 = ["id"]
const _hoisted_40 = ["id"]
const _hoisted_41 = ["id"]
const _hoisted_42 = ["id"]
const _hoisted_43 = ["id"]
const _hoisted_44 = ["id"]
const _hoisted_45 = ["id"]
const _hoisted_46 = ["id"]
const _hoisted_47 = ["id"]
const _hoisted_48 = ["id"]
const _hoisted_49 = ["id"]
const _hoisted_50 = ["id"]
const _hoisted_51 = ["id"]
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_54 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_55 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_56 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_57 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_58 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_59 = { class: "selectPageSize" }
const _hoisted_60 = { class: "layout gutter--xl" }
const _hoisted_61 = { class: "row" }
const _hoisted_62 = { class: "flex" }
const _hoisted_63 = { class: "readingSize" }
const _hoisted_64 = /*#__PURE__*/_createTextVNode("Er du sikker på at du vil slette ")
const _hoisted_65 = /*#__PURE__*/_createTextVNode("?")
const _hoisted_66 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_67 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_68 = { class: "display-6 center" }
const _hoisted_69 = /*#__PURE__*/_createTextVNode("Her kan du se alle medlemsoplysninger for ")
const _hoisted_70 = /*#__PURE__*/_createTextVNode(" med licensnummer ")
const _hoisted_71 = /*#__PURE__*/_createTextVNode("Personlige oplysninger")
const _hoisted_72 = { class: "layout gutter--md" }
const _hoisted_73 = { class: "row align--center" }
const _hoisted_74 = { class: "md6 flex memberModal" }
const _hoisted_75 = {
  key: 0,
  class: "md6 flex center"
}
const _hoisted_76 = /*#__PURE__*/_createTextVNode("Generer ny adgangskode")
const _hoisted_77 = {
  key: 1,
  class: "flex md6"
}
const _hoisted_78 = { class: "row align--center" }
const _hoisted_79 = { class: "flex md1" }
const _hoisted_80 = { class: "flex md7" }
const _hoisted_81 = { class: "flex md2" }
const _hoisted_82 = { class: "flex md2" }
const _hoisted_83 = { class: "flex md6" }
const _hoisted_84 = { class: "flex md6" }
const _hoisted_85 = { class: "row justify--space-around align--center" }
const _hoisted_86 = { class: "md3 flex memberModal" }
const _hoisted_87 = { class: "md3 flex memberModal center" }
const _hoisted_88 = { class: "row align--center" }
const _hoisted_89 = { class: "md4 flex memberModal" }
const _hoisted_90 = { class: "md4 flex memberModal" }
const _hoisted_91 = { class: "md4 flex memberModal" }
const _hoisted_92 = { class: "md6 flex memberModal" }
const _hoisted_93 = { class: "md3 flex memberModal" }
const _hoisted_94 = { class: "md3 flex memberModal" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_96 = /*#__PURE__*/_createTextVNode("Medlemskabsrelaterede oplysninger")
const _hoisted_97 = { class: "layout gutter--md" }
const _hoisted_98 = { class: "row align--center" }
const _hoisted_99 = { class: "md3 flex memberModal" }
const _hoisted_100 = { class: "md3 flex memberModal" }
const _hoisted_101 = { class: "md3 flex memberModal" }
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "md3 flex memberModal" }, null, -1))
const _hoisted_103 = { class: "flex md3" }
const _hoisted_104 = { class: "flex md3" }
const _hoisted_105 = /*#__PURE__*/_createTextVNode("Forny licensen")
const _hoisted_106 = { class: "flex md3" }
const _hoisted_107 = { class: "flex md3" }
const _hoisted_108 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md3" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Giv karantæne:")
], -1))
const _hoisted_109 = { class: "flex md4" }
const _hoisted_110 = { class: "flex md4" }
const _hoisted_111 = /*#__PURE__*/_createTextVNode("Opdater medlem")
const _hoisted_112 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_113 = { class: "tabHeight" }
const _hoisted_114 = { id: "newmembers" }
const _hoisted_115 = { key: 0 }
const _hoisted_116 = {
  key: 1,
  class: "form"
}
const _hoisted_117 = { key: 0 }
const _hoisted_118 = { class: "memberform-group" }
const _hoisted_119 = { class: "layout gutter--xl" }
const _hoisted_120 = { class: "row justify--space-around align--center" }
const _hoisted_121 = { class: "flex md6" }
const _hoisted_122 = { class: "flex md3" }
const _hoisted_123 = { class: "flex md3" }
const _hoisted_124 = { class: "row" }
const _hoisted_125 = {
  key: 0,
  class: "flex md6"
}
const _hoisted_126 = { class: "row" }
const _hoisted_127 = { class: "flex md6" }
const _hoisted_128 = { class: "flex md6" }
const _hoisted_129 = { class: "row" }
const _hoisted_130 = { class: "flex md4" }
const _hoisted_131 = { class: "flex md4" }
const _hoisted_132 = { class: "flex md4" }
const _hoisted_133 = { class: "row" }
const _hoisted_134 = { class: "flex md6" }
const _hoisted_135 = { class: "flex md3" }
const _hoisted_136 = { class: "flex md3" }
const _hoisted_137 = { class: "row" }
const _hoisted_138 = { class: "flex md6" }
const _hoisted_139 = { class: "row" }
const _hoisted_140 = { class: "flex md6" }
const _hoisted_141 = { class: "flex md6" }
const _hoisted_142 = { class: "row" }
const _hoisted_143 = { class: "flex md6" }
const _hoisted_144 = { class: "flex md6" }
const _hoisted_145 = { class: "flex md4 center" }
const _hoisted_146 = { class: "row justify--center" }
const _hoisted_147 = { class: "flex" }
const _hoisted_148 = /*#__PURE__*/_createTextVNode("Opret medlem")
const _hoisted_149 = { class: "tabHeight" }
const _hoisted_150 = { class: "row align--center justify--start" }
const _hoisted_151 = { class: "md1 flex ml-4" }
const _hoisted_152 = {
  class: "md3 flex",
  style: {"display":"flex"}
}
const _hoisted_153 = /*#__PURE__*/_createTextVNode("Søg")
const _hoisted_154 = { class: "row align--center justify--start mt-4" }
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex md1 ml-4" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Kolonner:")
], -1))
const _hoisted_156 = {
  class: "flex md10",
  style: {"display":"flex"}
}
const _hoisted_157 = { key: 0 }
const _hoisted_158 = {
  key: 1,
  class: "va-table-responsive"
}
const _hoisted_159 = {
  class: "va-table va-table--striped",
  style: {"width":"100%"}
}
const _hoisted_160 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", {
  class: "center",
  hidden: ""
}, "ID", -1))
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "center" }, "Handlinger", -1))
const _hoisted_162 = ["id"]
const _hoisted_163 = ["id"]
const _hoisted_164 = ["id"]
const _hoisted_165 = ["id"]
const _hoisted_166 = ["id"]
const _hoisted_167 = ["id"]
const _hoisted_168 = ["id"]
const _hoisted_169 = ["id"]
const _hoisted_170 = ["id"]
const _hoisted_171 = /*#__PURE__*/_createTextVNode("Vis/Rediger")
const _hoisted_172 = /*#__PURE__*/_createTextVNode("Slet")
const _hoisted_173 = { class: "row justify--center align--baseline paginationControls" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Side:", -1))
const _hoisted_175 = {
  key: 0,
  class: "mr-2"
}
const _hoisted_176 = {
  key: 1,
  class: "mr-2"
}
const _hoisted_177 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mr-2" }, "Antal rækker per side:", -1))
const _hoisted_178 = { class: "selectPageSize" }
const _hoisted_179 = { class: "layout gutter--xl" }
const _hoisted_180 = { class: "row justfiy--center" }
const _hoisted_181 = { class: "flex" }
const _hoisted_182 = { class: "readingSize" }
const _hoisted_183 = /*#__PURE__*/_createTextVNode("Er du sikker på at du vil slette ")
const _hoisted_184 = /*#__PURE__*/_createTextVNode("?")
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row justify--center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Handlingen kan ikke fortrydes")
  ])
], -1))
const _hoisted_186 = /*#__PURE__*/_createTextVNode("Ja")
const _hoisted_187 = /*#__PURE__*/_createTextVNode("Nej")
const _hoisted_188 = { class: "layout gutter--xl" }
const _hoisted_189 = { class: "row justify--center" }
const _hoisted_190 = { class: "flex" }
const _hoisted_191 = { class: "display-6 center" }
const _hoisted_192 = /*#__PURE__*/_createTextVNode("Her kan du se alle oplysninger for ")
const _hoisted_193 = { class: "row" }
const _hoisted_194 = { class: "md4 flex" }
const _hoisted_195 = { class: "md4 flex" }
const _hoisted_196 = { class: "md4 flex" }
const _hoisted_197 = { class: "row align--center" }
const _hoisted_198 = { class: "md4 flex" }
const _hoisted_199 = { class: "flex md4" }
const _hoisted_200 = { class: "flex md4" }
const _hoisted_201 = { class: "row align--center center" }
const _hoisted_202 = { class: "flex md4" }
const _hoisted_203 = { class: "flex md4" }
const _hoisted_204 = { class: "flex md4" }
const _hoisted_205 = /*#__PURE__*/_createTextVNode("Opdater spiller")
const _hoisted_206 = /*#__PURE__*/_createTextVNode("Annuller")
const _hoisted_207 = { class: "tabHeight" }
const _hoisted_208 = { id: "newforeignplayers" }
const _hoisted_209 = { key: 0 }
const _hoisted_210 = {
  key: 1,
  class: "form"
}
const _hoisted_211 = { key: 0 }
const _hoisted_212 = { class: "memberform-group" }
const _hoisted_213 = { class: "layout gutter--xl" }
const _hoisted_214 = { class: "row" }
const _hoisted_215 = { class: "flex md4" }
const _hoisted_216 = { class: "flex md4" }
const _hoisted_217 = { class: "flex md4" }
const _hoisted_218 = { class: "row align--center" }
const _hoisted_219 = { class: "flex md4" }
const _hoisted_220 = { class: "flex md4" }
const _hoisted_221 = { class: "flex md4" }
const _hoisted_222 = { class: "row align--center justify--center center" }
const _hoisted_223 = { class: "flex" }
const _hoisted_224 = { class: "row justify--center" }
const _hoisted_225 = { class: "flex" }
const _hoisted_226 = /*#__PURE__*/_createTextVNode("Opret udenlandsk spiller")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_va_tab = _resolveComponent("va-tab")!
  const _component_va_tabs = _resolveComponent("va-tabs")!
  const _component_va_icon = _resolveComponent("va-icon")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_popover = _resolveComponent("va-popover")!
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_select = _resolveComponent("va-select")!
  const _component_va_button_dropdown = _resolveComponent("va-button-dropdown")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_it_divider = _resolveComponent("it-divider")!
  const _component_va_button_group = _resolveComponent("va-button-group")!
  const _component_va_modal = _resolveComponent("va-modal")!
  const _component_va_card_title = _resolveComponent("va-card-title")!
  const _component_va_card_content = _resolveComponent("va-card-content")!
  const _component_va_card = _resolveComponent("va-card")!
  const _component_va_form = _resolveComponent("va-form")!
  const _component_va_radio = _resolveComponent("va-radio")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.msg), 1),
      _createVNode(_component_va_tabs, {
        class: "adminTabs",
        modelValue: _ctx.tabValue,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tabValue) = $event))
      }, {
        tabs: _withCtx(() => [
          (_openBlock(), _createElementBlock(_Fragment, null, _renderList(['Vis og rediger medlemmer', 'Opret nyt medlem', 'Vis og rediger udenlandske spillere', 'Opret ny udenlandsk spiller'], (title) => {
            return _createVNode(_component_va_tab, {
              key: title,
              name: title
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(title), 1)
              ]),
              _: 2
            }, 1032, ["name"])
          }), 64))
        ]),
        _: 1
      }, 8, ["modelValue"]),
      _withDirectives(_createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.columnSort('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.memberSearchInputValue,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.memberSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.findMember()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.findMember()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_va_select, {
              label: "Licensstatus",
              class: "ml-4",
              modelValue: _ctx.filterStatusStringValue,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.filterStatusStringValue) = $event)),
              options: _ctx.filterStatusStringOptions,
              bordered: "",
              style: {"width":"75%"}
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createVNode(_component_va_select, {
              class: "ml-4",
              label: "Klubrolle",
              modelValue: _ctx.clubRoleFilterValue,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.clubRoleFilterValue) = $event)),
              options: _ctx.clubRoleFilterOptions,
              bordered: "",
              searchable: ""
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_va_button_dropdown, {
              label: "Eksporter",
              modelValue: _ctx.exportDropDown,
              "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.exportDropDown) = $event)),
              "close-on-content-click": false
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_va_select, {
                      label: "Klub",
                      bordered: "",
                      modelValue: _ctx.exportClubFilterValue,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.exportClubFilterValue) = $event)),
                      options: _ctx.exportClubFilterOptions,
                      "text-by": (exportClubFilterOptions) => exportClubFilterOptions.name,
                      "track-by": (exportClubFilterOptions) => exportClubFilterOptions.id,
                      searchable: ""
                    }, null, 8, ["modelValue", "options", "text-by", "track-by"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("div", _hoisted_15, [
                    _createVNode(_component_va_select, {
                      label: "Licensstatus",
                      bordered: "",
                      modelValue: _ctx.exportStatusFilterValue,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.exportStatusFilterValue) = $event)),
                      options: _ctx.exportStatusFilterOptions,
                      "text-by": (exportStatusFilterOptions) => exportStatusFilterOptions.name,
                      "track-by": (exportStatusFilterOptions) => exportStatusFilterOptions.value
                    }, null, 8, ["modelValue", "options", "text-by", "track-by"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", _hoisted_17, [
                    _createVNode(_component_va_select, {
                      label: "Medlem rolle",
                      modelValue: _ctx.exportRoleFilterValue,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.exportRoleFilterValue) = $event)),
                      options: _ctx.clubRoleAndUserGroupOptions,
                      bordered: "",
                      searchable: ""
                    }, null, 8, ["modelValue", "options"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _createVNode(_component_va_select, {
                      label: "Vælg felter at inkludere",
                      modelValue: _ctx.exportFieldsFilterValue,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.exportFieldsFilterValue) = $event)),
                      options: _ctx.exportFieldsFilterOptions,
                      "text-by": (exportFieldsFilterOptions) => exportFieldsFilterOptions.name,
                      bordered: "",
                      multiple: "",
                      searchable: ""
                    }, null, 8, ["modelValue", "options", "text-by"])
                  ])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _createVNode(_component_va_button, {
                      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.exportDataToExcel())),
                      disabled: !(_ctx.exportFieldsFilterValue.length > 0)
                    }, {
                      default: _withCtx(() => [
                        _hoisted_22
                      ]),
                      _: 1
                    }, 8, ["disabled"])
                  ])
                ]),
                _hoisted_23
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_va_button, {
              onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.updateMemberRights()))
            }, {
              default: _withCtx(() => [
                _hoisted_25
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "licenseStatus",
              label: "Licensstatus"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "licenseExpires",
              label: "Licens udløber"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "licenseNumber",
              label: "Licensnummer"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "name",
              label: "Navn"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "gender",
              label: "Køn"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "paradart",
              label: "Paradart"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "email",
              label: "Email"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "telephone",
              label: "Telefon"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "club",
              label: "Klub"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "userGroup",
              label: "Brugerrolle"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "clubRole",
              label: "Klubrolle"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "memberStart",
              label: "Medlem siden"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "quarantine",
              label: "Karantæne"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnName,
              "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.columnName) = $event)),
              "array-value": "isQuarantine",
              label: "Er Karantæne"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_29, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, [
              _createElementVNode("table", _hoisted_31, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_32,
                    _withDirectives(_createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[28] || (_cache[28] = ($event: any) => (_ctx.columnSort('status')))
                    }, "Licens", 512), [
                      [_vShow, _ctx.showColumn('licenseStatus')]
                    ]),
                    _withDirectives(_createElementVNode("th", _hoisted_33, "Licens udløber", 512), [
                      [_vShow, _ctx.showColumn('licenseExpires')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[29] || (_cache[29] = ($event: any) => (_ctx.columnSort('licens')))
                    }, "Licens Nr.", 512), [
                      [_vShow, _ctx.showColumn('licenseNumber')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[30] || (_cache[30] = ($event: any) => (_ctx.columnSort('navn')))
                    }, "Navn", 512), [
                      [_vShow, _ctx.showColumn('name')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[31] || (_cache[31] = ($event: any) => (_ctx.columnSort('koen')))
                    }, "Køn", 512), [
                      [_vShow, _ctx.showColumn('gender')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting center",
                      onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.columnSort('paradart')))
                    }, "Paradart", 512), [
                      [_vShow, _ctx.showColumn('paradart')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[33] || (_cache[33] = ($event: any) => (_ctx.columnSort('email')))
                    }, "Email", 512), [
                      [_vShow, _ctx.showColumn('email')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "center sorting",
                      onClick: _cache[34] || (_cache[34] = ($event: any) => (_ctx.columnSort('telefon')))
                    }, "Telefonnummer", 512), [
                      [_vShow, _ctx.showColumn('telephone')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[35] || (_cache[35] = ($event: any) => (_ctx.columnSort('klub')))
                    }, "Klub", 512), [
                      [_vShow, _ctx.showColumn('club')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[36] || (_cache[36] = ($event: any) => (_ctx.columnSort('brugerRolle')))
                    }, "Brugerrolle", 512), [
                      [_vShow, _ctx.showColumn('userGroup')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[37] || (_cache[37] = ($event: any) => (_ctx.columnSort('klubrolle')))
                    }, "Klubrolle", 512), [
                      [_vShow, _ctx.showColumn('clubRole')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[38] || (_cache[38] = ($event: any) => (_ctx.columnSort('medlemSiden')))
                    }, "Medlem siden", 512), [
                      [_vShow, _ctx.showColumn('memberStart')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[39] || (_cache[39] = ($event: any) => (_ctx.columnSort('karantaene')))
                    }, "Karantæne", 512), [
                      [_vShow, _ctx.showColumn('quarantine')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[40] || (_cache[40] = ($event: any) => (_ctx.columnSort('medlem_karantaene')))
                    }, "Er Karantæne", 512), [
                      [_vShow, _ctx.showColumn('isQuarantine')]
                    ]),
                    _hoisted_34
                  ])
                ]),
                _withDirectives(_createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.medlemers, (medlem, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: Number(medlem.id)
                    }, [
                      _createElementVNode("td", {
                        id: 'memberstable-row' + (index+1),
                        class: "center",
                        hidden: ""
                      }, _toDisplayString(medlem.id), 9, _hoisted_35),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1),
                        class: "center"
                      }, [
                        _createVNode(_component_va_icon, {
                          name: _ctx.activeLicense(medlem.medlem_licens_slut) ? 'check_box': 'check_box_outline_blank',
                          color: _ctx.activeLicense(medlem.medlem_licens_slut) ? 'primary' : 'rgb(255, 172, 10)'
                        }, null, 8, ["name", "color"])
                      ], 8, _hoisted_36), [
                        [_vShow, _ctx.showColumn('licenseStatus')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1),
                        class: "center"
                      }, _toDisplayString(_ctx.licenseExpires(medlem.medlem_licens_slut)), 9, _hoisted_37), [
                        [_vShow, _ctx.showColumn('licenseExpires')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1),
                        class: "center"
                      }, _toDisplayString(medlem.medlem_licens), 9, _hoisted_38), [
                        [_vShow, _ctx.showColumn('licenseNumber')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1)
                      }, _toDisplayString(medlem.user_id.firstname) + " " + _toDisplayString(medlem.user_id.lastname), 9, _hoisted_39), [
                        [_vShow, _ctx.showColumn('name')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1)
                      }, _toDisplayString(medlem?.koen_id?.Koen), 9, _hoisted_40), [
                        [_vShow, _ctx.showColumn('gender')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1),
                        class: "center"
                      }, [
                        _createVNode(_component_va_icon, {
                          name: medlem.medlem_paradart ? 'done' : '',
                          color: medlem.medlem_paradart ? 'success' : ''
                        }, null, 8, ["name", "color"])
                      ], 8, _hoisted_41), [
                        [_vShow, _ctx.showColumn('paradart')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1)
                      }, _toDisplayString(medlem.user_id.email), 9, _hoisted_42), [
                        [_vShow, _ctx.showColumn('email')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1),
                        class: "center"
                      }, _toDisplayString(medlem.user_id.phone), 9, _hoisted_43), [
                        [_vShow, _ctx.showColumn('telephone')]
                      ]),
                      (medlem.klubber_id)
                        ? _withDirectives((_openBlock(), _createElementBlock("td", {
                            key: 0,
                            id: 'memberstable-row' + (index+1)
                          }, _toDisplayString(medlem.klubber_id.klubber_klubnavn), 9, _hoisted_44)), [
                            [_vShow, _ctx.showColumn('club')]
                          ])
                        : _withDirectives((_openBlock(), _createElementBlock("td", {
                            key: 1,
                            id: 'memberstable-row' + (index+1)
                          }, "Ingen", 8, _hoisted_45)), [
                            [_vShow, _ctx.showColumn('club')]
                          ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1)
                      }, _toDisplayString(_ctx.getUserGroupFromId(medlem.user_id.usrgroup)), 9, _hoisted_46), [
                        [_vShow, _ctx.showColumn('userGroup')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1),
                        class: "capitalize"
                      }, _toDisplayString((medlem.medlem_klubrolle === null ? 'Ingen' : medlem.medlem_klubrolle).replaceAll('_', ' ')), 9, _hoisted_47), [
                        [_vShow, _ctx.showColumn('clubRole')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1)
                      }, _toDisplayString(new Date(medlem.medlem_begyndelse).toLocaleDateString('da-DK', { day: '2-digit', month: '2-digit', year: '2-digit' }).replaceAll('-', '/')), 9, _hoisted_48), [
                        [_vShow, _ctx.showColumn('memberStart')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1)
                      }, [
                        _createVNode(_component_va_icon, {
                          size: "large",
                          name: (_ctx.testActiveQuarantine(medlem.medlem_karantaene_dato, medlem.medlem_karantaene_slutdato) ? 'no_accounts' : ''),
                          color: "danger"
                        }, null, 8, ["name"]),
                        _createTextVNode(" " + _toDisplayString((medlem.medlem_karantaene_dato === null ? '' : _ctx.toDanishDateString(medlem.medlem_karantaene_dato) + ' til ') + (medlem.medlem_karantaene_slutdato === null ? '' : _ctx.toDanishDateString(medlem.medlem_karantaene_slutdato))), 1)
                      ], 8, _hoisted_49), [
                        [_vShow, _ctx.showColumn('quarantine')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'memberstable-row' + (index+1)
                      }, [
                        _createVNode(_component_va_icon, {
                          size: "large",
                          color: "danger"
                        }),
                        _createTextVNode(" " + _toDisplayString(medlem.medlem_karantaene === true ? 'Yes' : 'No'), 1)
                      ], 8, _hoisted_50), [
                        [_vShow, _ctx.showColumn('isQuarantine')]
                      ]),
                      _createElementVNode("td", {
                        id: 'memberstable-row' + (index+1)
                      }, [
                        _createVNode(_component_va_button_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_button, {
                              class: "btn",
                              color: "info",
                              rounded: false,
                              name: "editmember",
                              onClick: ($event: any) => (_ctx.editMember(medlem.documentId))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_52
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_va_button, {
                              class: "btn",
                              color: "danger",
                              rounded: false,
                              name: "deletemember",
                              onClick: ($event: any) => (_ctx.deleteMemberWarning(Number(medlem.id), medlem.user_id.firstname, medlem.user_id.lastname, medlem.documentId))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_53
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ], 8, _hoisted_51)
                    ]))
                  }), 128))
                ], 512), [
                  [_vShow, _ctx.columnName.length > 0]
                ])
              ])
            ])),
        _createElementVNode("div", _hoisted_54, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[41] || (_cache[41] = ($event: any) => (_ctx.jumpToPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[42] || (_cache[42] = ($event: any) => (_ctx.turnToNewPage(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[43] || (_cache[43] = ($event: any) => (_ctx.turnToNewPage(-1)))
          }),
          _hoisted_55,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.currentPage) = $event)),
            type: "number",
            onKeyup: _cache[45] || (_cache[45] = _withKeys(($event: any) => (_ctx.jumpToPage(_ctx.currentPage)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPage]
          ]),
          (_ctx.totalNumberOfPages === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_56, " af " + _toDisplayString(_ctx.totalNumberOfPages+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_57, " af " + _toDisplayString(_ctx.totalNumberOfPages), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[46] || (_cache[46] = ($event: any) => (_ctx.turnToNewPage(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[47] || (_cache[47] = ($event: any) => (_ctx.turnToNewPage(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[48] || (_cache[48] = ($event: any) => (_ctx.jumpToPage(_ctx.totalNumberOfPages)))
          }),
          _hoisted_58,
          _createElementVNode("div", _hoisted_59, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueString,
              "onUpdate:modelValue": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.pageSizeValueString) = $event)),
              options: _ctx.pageSizeOptions,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.warningModal,
          "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.warningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          color: "danger"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "danger",
              onClick: _cache[50] || (_cache[50] = ($event: any) => (_ctx.deleteMember(_ctx.deleteMemberId), _ctx.$Message.success({ text: 'Medlemmet er blevet slettet' })))
            }, {
              default: _withCtx(() => [
                _hoisted_66
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.warningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_67
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_60, [
              _createElementVNode("div", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("p", _hoisted_63, [
                    _hoisted_64,
                    _createElementVNode("strong", null, _toDisplayString(_ctx.deleteMemberName), 1),
                    _hoisted_65
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editMemberModal,
          "onUpdate:modelValue": _cache[82] || (_cache[82] = ($event: any) => ((_ctx.editMemberModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[80] || (_cache[80] = ($event: any) => (_ctx.updateMember()))
            }, {
              default: _withCtx(() => [
                _hoisted_111
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[81] || (_cache[81] = ($event: any) => (_ctx.$Message.warning({ text: 'Redigeringen blev annulleret' }), (_ctx.editMemberModal = false), _ctx.cancelMemberEdit()))
            }, {
              default: _withCtx(() => [
                _hoisted_112
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("h6", _hoisted_68, [
              _hoisted_69,
              _createElementVNode("u", null, _toDisplayString(_ctx.medlemData.brugerFornavn) + " " + _toDisplayString(_ctx.medlemData.brugerEfternavn), 1),
              _hoisted_70,
              _createElementVNode("u", null, _toDisplayString(_ctx.medlemData.medlemLicens), 1)
            ]),
            _createVNode(_component_va_form, {
              ref: "editMemberForm",
              onValidation: _cache[79] || (_cache[79] = ($event: any) => (_ctx.validation = $event))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_card, {
                  color: "#afcfff",
                  gradient: true,
                  stripe: true,
                  "stripe-color": "#2f5f4f"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_card_title, null, {
                      default: _withCtx(() => [
                        _hoisted_71
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_va_card_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_72, [
                          _createElementVNode("div", _hoisted_73, [
                            _createElementVNode("div", _hoisted_74, [
                              _createVNode(_component_va_input, {
                                type: "text",
                                class: "inputSizing",
                                modelValue: _ctx.medlemData.brugerBrugernavn,
                                "onUpdate:modelValue": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.medlemData.brugerBrugernavn) = $event)),
                                label: "Brugernavn",
                                rules: [(v) => v.trim().length > 1 || 'Brugernavn mangler'],
                                placeholder: "Unikt brugernavn",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            (!_ctx.newPassword)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                  _createVNode(_component_va_button, {
                                    onClick: _cache[54] || (_cache[54] = ($event: any) => (_ctx.generateNewPassword())),
                                    color: "info",
                                    gradient: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_76
                                    ]),
                                    _: 1
                                  })
                                ]))
                              : (_openBlock(), _createElementBlock("div", _hoisted_77, [
                                  _createElementVNode("div", _hoisted_78, [
                                    _createElementVNode("div", _hoisted_79, [
                                      _createVNode(_component_va_icon, {
                                        class: "refreshBtn",
                                        name: "refresh",
                                        onClick: _cache[55] || (_cache[55] = ($event: any) => (_ctx.generateNewPassword()))
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_80, [
                                      _createVNode(_component_va_input, {
                                        class: "inputSizing",
                                        modelValue: _ctx.newPasswordString,
                                        "onUpdate:modelValue": _cache[56] || (_cache[56] = ($event: any) => ((_ctx.newPasswordString) = $event)),
                                        type: "text",
                                        label: "Ny adgangskode (minimum 8 tegn)",
                                        rules: [(v) => (v.length === 0 || v.length >= 8) || 'Adgangskoden skal indeholde både store og små bogstaver, tal og specialtegn'],
                                        placeholder: "********",
                                        bordered: ""
                                      }, null, 8, ["modelValue", "rules"])
                                    ]),
                                    _createElementVNode("div", _hoisted_81, [
                                      _createVNode(_component_va_button, {
                                        onClick: _cache[57] || (_cache[57] = ($event: any) => (_ctx.updatePassword())),
                                        color: "success",
                                        gradient: "",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_va_icon, { name: "task_alt" })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_82, [
                                      _createVNode(_component_va_button, {
                                        onClick: _cache[58] || (_cache[58] = ($event: any) => (_ctx.cancelNewPassword())),
                                        color: "secondary",
                                        gradient: "",
                                        size: "small"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_va_icon, { name: "clear" })
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ])
                                ])),
                            _createElementVNode("div", _hoisted_83, [
                              _createVNode(_component_va_input, {
                                class: "inputSizing",
                                type: "text",
                                modelValue: _ctx.medlemData.brugerFornavn,
                                "onUpdate:modelValue": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.medlemData.brugerFornavn) = $event)),
                                label: "Fornavn",
                                rules: [(v) => v.trim().length > 1 || 'Der manger et fornavn'],
                                placeholder: "Navn",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_84, [
                              _createVNode(_component_va_input, {
                                class: "inputSizing",
                                type: "text",
                                modelValue: _ctx.medlemData.brugerEfternavn,
                                "onUpdate:modelValue": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.medlemData.brugerEfternavn) = $event)),
                                label: "Efternavn",
                                rules: [(v) => v.trim().length > 1 || 'Der mangler et efternavn'],
                                placeholder: "Navn",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_85, [
                            _createElementVNode("div", _hoisted_86, [
                              _createVNode(_component_va_select, {
                                modelValue: _ctx.medlemData.medlemKoen,
                                "onUpdate:modelValue": _cache[61] || (_cache[61] = ($event: any) => ((_ctx.medlemData.medlemKoen) = $event)),
                                label: "Køn",
                                options: _ctx.koenStringOptions,
                                rules: [(v) => v !== 'Vælg her' || 'Medlemmet skal have et køn'],
                                bordered: ""
                              }, null, 8, ["modelValue", "options", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_87, [
                              _createVNode(_component_va_checkbox, {
                                modelValue: _ctx.medlemData.paradartspillerCheck,
                                "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.medlemData.paradartspillerCheck) = $event)),
                                label: "Paradartspiller"
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_88, [
                            _createElementVNode("div", _hoisted_89, [
                              _createVNode(_component_va_input, {
                                class: "center inputSizing",
                                type: "date",
                                modelValue: _ctx.medlemData.medlemFoedselsdag,
                                "onUpdate:modelValue": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.medlemData.medlemFoedselsdag) = $event)),
                                label: "Fødselsdag",
                                rules: [(v) => v.length >= 1 || 'Fødselsdag er ikke angivet'],
                                placeholder: "Dato",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_90, [
                              _createVNode(_component_va_input, {
                                class: "inputSizing",
                                type: "text",
                                modelValue: _ctx.medlemData.brugerTelefon,
                                "onUpdate:modelValue": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.medlemData.brugerTelefon) = $event)),
                                label: "Telefon-nr.",
                                rules: [(v) => v.trim().length > 7 || 'Telefonnummeret mangler'],
                                placeholder: "Nr. med mindst 8 cifre",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_91, [
                              _createVNode(_component_va_input, {
                                class: "inputSizing",
                                type: "email",
                                modelValue: _ctx.medlemData.brugerEmail,
                                "onUpdate:modelValue": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.medlemData.brugerEmail) = $event)),
                                label: "Email",
                                rules: [(v) => _ctx.testLegalEmail(v) || 'Der mangler en mailadresse'],
                                placeholder: "mailuser@domain.tld",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_92, [
                              _createVNode(_component_va_input, {
                                type: "text",
                                class: "inputSizing",
                                modelValue: _ctx.medlemData.medlemVejnummer,
                                "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.medlemData.medlemVejnummer) = $event)),
                                label: "Adresse",
                                rules: [(v) => v.trim().length >= 1 || 'Der mangler en adresse'],
                                placeholder: "Adresse",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_93, [
                              _createVNode(_component_va_input, {
                                class: "inputSizing",
                                type: "text",
                                modelValue: _ctx.medlemData.medlemPostnummer,
                                "onUpdate:modelValue": _cache[67] || (_cache[67] = ($event: any) => ((_ctx.medlemData.medlemPostnummer) = $event)),
                                onFocus: _cache[68] || (_cache[68] = ($event: any) => (_ctx.medlemByPostnummerInputFocus = 2)),
                                label: "Postnummer",
                                rules: [(v) => v.length === 4 || 'Postnummeret mangler'],
                                placeholder: "Nummer",
                                bordered: ""
                              }, null, 8, ["modelValue", "rules"])
                            ]),
                            _createElementVNode("div", _hoisted_94, [
                              _createVNode(_component_va_input, {
                                class: "inputSizing",
                                type: "text",
                                modelValue: _ctx.medlemData.medlemBy,
                                "onUpdate:modelValue": _cache[69] || (_cache[69] = ($event: any) => ((_ctx.medlemData.medlemBy) = $event)),
                                onFocus: _cache[70] || (_cache[70] = ($event: any) => (_ctx.medlemByPostnummerInputFocus = 1)),
                                label: "By",
                                placeholder: "By",
                                bordered: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _hoisted_95,
                _createVNode(_component_va_card, {
                  color: "#afcfff",
                  gradient: true,
                  stripe: true,
                  "stripe-color": "#2f5f4f"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_card_title, null, {
                      default: _withCtx(() => [
                        _hoisted_96
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_va_card_content, null, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_97, [
                          _createElementVNode("div", _hoisted_98, [
                            _createElementVNode("div", _hoisted_99, [
                              _createVNode(_component_va_select, {
                                label: "Klubrolle",
                                modelValue: _ctx.clubRoleStringValue,
                                "onUpdate:modelValue": _cache[71] || (_cache[71] = ($event: any) => ((_ctx.clubRoleStringValue) = $event)),
                                options: _ctx.clubRoleStringOptions,
                                bordered: "",
                                "prevent-overflow": ""
                              }, null, 8, ["modelValue", "options"])
                            ]),
                            _createElementVNode("div", _hoisted_100, [
                              _createVNode(_component_va_select, {
                                label: "Medlem af",
                                modelValue: _ctx.clubStringValue,
                                "onUpdate:modelValue": _cache[72] || (_cache[72] = ($event: any) => ((_ctx.clubStringValue) = $event)),
                                options: _ctx.clubStringOptions,
                                "text-by": (clubStringOptions) => clubStringOptions.name,
                                searchable: "",
                                bordered: "",
                                "prevent-overflow": ""
                              }, null, 8, ["modelValue", "options", "text-by"])
                            ]),
                            _createElementVNode("div", _hoisted_101, [
                              _createVNode(_component_va_select, {
                                label: "Angiv brugerrettigheder",
                                modelValue: _ctx.userGroupStringValue,
                                "onUpdate:modelValue": _cache[73] || (_cache[73] = ($event: any) => ((_ctx.userGroupStringValue) = $event)),
                                options: _ctx.userGroupStringOptions,
                                "text-by": (userGroupStringOptions) => userGroupStringOptions.name,
                                "track-by": (userGroupStringOptions) => userGroupStringOptions.id,
                                searchable: "",
                                bordered: "",
                                "prevent-overflow": ""
                              }, null, 8, ["modelValue", "options", "text-by", "track-by"])
                            ]),
                            _hoisted_102,
                            _createElementVNode("div", _hoisted_103, [
                              _createElementVNode("p", null, "Licens Udløber: " + _toDisplayString(_ctx.toDanishDateString(_ctx.medlemData.medlemLicensUdlober)), 1)
                            ]),
                            _createElementVNode("div", _hoisted_104, [
                              _createVNode(_component_va_button, {
                                color: "info",
                                disabled: _ctx.disableLicenseRenewalBtn(_ctx.medlemData.medlemLicensUdlober) && !_ctx.customLicenseEndDate,
                                onClick: _cache[74] || (_cache[74] = ($event: any) => (_ctx.renewLicens(_ctx.medlemData.medlemLicensUdlober)))
                              }, {
                                default: _withCtx(() => [
                                  _hoisted_105
                                ]),
                                _: 1
                              }, 8, ["disabled"])
                            ]),
                            _createElementVNode("div", _hoisted_106, [
                              _createVNode(_component_va_checkbox, {
                                modelValue: _ctx.customLicenseEndDate,
                                "onUpdate:modelValue": _cache[75] || (_cache[75] = ($event: any) => ((_ctx.customLicenseEndDate) = $event)),
                                label: "Angiv slutdato for licensen"
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_107, [
                              _withDirectives(_createVNode(_component_va_input, {
                                modelValue: _ctx.newLicensEndDate,
                                "onUpdate:modelValue": _cache[76] || (_cache[76] = ($event: any) => ((_ctx.newLicensEndDate) = $event)),
                                label: "Ny slutdato for licensen",
                                type: "date",
                                bordered: ""
                              }, null, 8, ["modelValue"]), [
                                [_vShow, _ctx.customLicenseEndDate]
                              ])
                            ]),
                            _hoisted_108,
                            _createElementVNode("div", _hoisted_109, [
                              _createVNode(_component_va_input, {
                                type: "date",
                                modelValue: _ctx.medlemData.medlemKarantaeneDato,
                                "onUpdate:modelValue": _cache[77] || (_cache[77] = ($event: any) => ((_ctx.medlemData.medlemKarantaeneDato) = $event)),
                                class: "center",
                                label: "Karantæne startdato",
                                placeholder: "Dato",
                                bordered: ""
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_110, [
                              _createVNode(_component_va_input, {
                                type: "date",
                                modelValue: _ctx.medlemData.medlemKarantaeneSlutdato,
                                "onUpdate:modelValue": _cache[78] || (_cache[78] = ($event: any) => ((_ctx.medlemData.medlemKarantaeneSlutdato) = $event)),
                                class: "center",
                                label: "Karantæne slutdato",
                                placeholder: "Dato",
                                bordered: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ])
                        ])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512)
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger medlemmer']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_113, [
        _createElementVNode("div", _hoisted_114, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_115, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_116, [
                (!_ctx.submitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_117, [
                      _createElementVNode("div", _hoisted_118, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "newmemberform"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_119, [
                              _createElementVNode("div", _hoisted_120, [
                                _createElementVNode("div", _hoisted_121, [
                                  _createVNode(_component_va_input, {
                                    modelValue: _ctx.medlemData.brugerBrugernavn,
                                    "onUpdate:modelValue": _cache[83] || (_cache[83] = ($event: any) => ((_ctx.medlemData.brugerBrugernavn) = $event)),
                                    type: "text",
                                    label: "Brugernavn",
                                    rules: [(brugerBrugernavn) => _ctx.medlemData.brugerBrugernavn.length > 1 || 'Brugernavn mangler'],
                                    placeholder: "Unikt brugernavn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_122, [
                                  _createVNode(_component_va_select, {
                                    modelValue: _ctx.koenStringValue,
                                    "onUpdate:modelValue": _cache[84] || (_cache[84] = ($event: any) => ((_ctx.koenStringValue) = $event)),
                                    options: _ctx.koenStringOptions,
                                    label: "Køn",
                                    rules: [(koenStringValue) => _ctx.medlemData.koenStringValue != '' || 'Køn ikke angivet'],
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_123, [
                                  _createVNode(_component_va_checkbox, {
                                    modelValue: _ctx.medlemData.paradartspillerCheck,
                                    "onUpdate:modelValue": _cache[85] || (_cache[85] = ($event: any) => ((_ctx.medlemData.paradartspillerCheck) = $event)),
                                    label: "Paradartspiller"
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_124, [
                                _createElementVNode("div", {
                                  class: _normalizeClass(_ctx.medlemData.brugerPassword.length < 8 ? 'flex md12' : 'flex md6')
                                }, [
                                  _createVNode(_component_va_input, {
                                    modelValue: _ctx.medlemData.brugerPassword,
                                    "onUpdate:modelValue": _cache[86] || (_cache[86] = ($event: any) => ((_ctx.medlemData.brugerPassword) = $event)),
                                    type: "password",
                                    label: "Adgangskode (minimum 8 tegn)",
                                    rules: [(brugerPassword) => _ctx.passwordTest(_ctx.medlemData.brugerPassword) || 'Adgangskoden skal indeholde både store og små bogstaver, tal og specialtegn'],
                                    placeholder: "********",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ], 2),
                                (_ctx.medlemData.brugerPassword.length >= 8)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_125, [
                                      _createVNode(_component_va_input, {
                                        modelValue: _ctx.repeatPassword,
                                        "onUpdate:modelValue": _cache[87] || (_cache[87] = ($event: any) => ((_ctx.repeatPassword) = $event)),
                                        type: "password",
                                        label: "Gentag adgangskoden",
                                        rules: [value => value === _ctx.medlemData.brugerPassword || 'Adgangskoderne skal være ens'],
                                        placeholder: "********",
                                        bordered: "",
                                        disabled: _ctx.medlemData.brugerPassword.length < 8,
                                        hidden: _ctx.medlemData.brugerPassword.length < 8
                                      }, null, 8, ["modelValue", "rules", "disabled", "hidden"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _createElementVNode("div", _hoisted_126, [
                                _createElementVNode("div", _hoisted_127, [
                                  _createVNode(_component_va_input, {
                                    modelValue: _ctx.medlemData.brugerFornavn,
                                    "onUpdate:modelValue": _cache[88] || (_cache[88] = ($event: any) => ((_ctx.medlemData.brugerFornavn) = $event)),
                                    type: "text",
                                    label: "Fornavn",
                                    rules: [(brugerFornavn) => _ctx.medlemData.brugerFornavn.length > 1 || 'Der mangler et fornavn'],
                                    placeholder: "Navn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_128, [
                                  _createVNode(_component_va_input, {
                                    modelValue: _ctx.medlemData.brugerEfternavn,
                                    "onUpdate:modelValue": _cache[89] || (_cache[89] = ($event: any) => ((_ctx.medlemData.brugerEfternavn) = $event)),
                                    type: "text",
                                    label: "Efternavn",
                                    rules: [(brugerEfternavn) => _ctx.medlemData.brugerEfternavn.length > 1 || 'Der mangler et efternavn'],
                                    placeholder: "Navn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_129, [
                                _createElementVNode("div", _hoisted_130, [
                                  _createVNode(_component_va_input, {
                                    modelValue: _ctx.medlemData.medlemFoedselsdag,
                                    "onUpdate:modelValue": _cache[90] || (_cache[90] = ($event: any) => ((_ctx.medlemData.medlemFoedselsdag) = $event)),
                                    type: "date",
                                    label: "Fødselsdag",
                                    rules: [(medlemFoedselsdag) => _ctx.medlemData.medlemFoedselsdag != '' || 'Der mangler en fødselsdag'],
                                    placeholder: "Dato",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_131, [
                                  _createVNode(_component_va_input, {
                                    modelValue: _ctx.medlemData.brugerTelefon,
                                    "onUpdate:modelValue": _cache[91] || (_cache[91] = ($event: any) => ((_ctx.medlemData.brugerTelefon) = $event)),
                                    type: "number",
                                    label: "Telefon-nr.",
                                    rules: [(brugerTelefon) => _ctx.medlemData.brugerTelefon.length > 7 || 'Telefonnummer mangler'],
                                    placeholder: "Nr. med mindst 8 cifre",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_132, [
                                  _createVNode(_component_va_input, {
                                    modelValue: _ctx.medlemData.brugerEmail,
                                    "onUpdate:modelValue": _cache[92] || (_cache[92] = ($event: any) => ((_ctx.medlemData.brugerEmail) = $event)),
                                    type: "email",
                                    label: "Email",
                                    rules: [(brugerEmail) => _ctx.medlemData.brugerEmail.length > 2 && _ctx.medlemData.brugerEmail.includes('@') || 'Der mangler en mailadresse'],
                                    placeholder: "mailuser@domain.tld",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_133, [
                                _createElementVNode("div", _hoisted_134, [
                                  _createVNode(_component_va_input, {
                                    modelValue: _ctx.medlemData.medlemVejnummer,
                                    "onUpdate:modelValue": _cache[93] || (_cache[93] = ($event: any) => ((_ctx.medlemData.medlemVejnummer) = $event)),
                                    type: "text",
                                    label: "Vej/gade og husnummer",
                                    rules: [(medlemVejnummer) => _ctx.medlemData.medlemVejnummer.length > 1 || 'Der mangler oplysninger omkring vej/gade og husnummer'],
                                    placeholder: "Adresse",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_135, [
                                  _createVNode(_component_va_input, {
                                    modelValue: _ctx.medlemData.medlemPostnummer,
                                    "onUpdate:modelValue": _cache[94] || (_cache[94] = ($event: any) => ((_ctx.medlemData.medlemPostnummer) = $event)),
                                    onFocus: _cache[95] || (_cache[95] = ($event: any) => (_ctx.medlemByPostnummerInputFocus = 2)),
                                    type: "number",
                                    label: "Postnummer",
                                    rules: [(medlemPostnummer) => _ctx.medlemData.medlemPostnummer.length === 4 || 'Postnummer mangler'],
                                    placeholder: "Nummer",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_136, [
                                  _createVNode(_component_va_input, {
                                    modelValue: _ctx.medlemData.medlemBy,
                                    "onUpdate:modelValue": _cache[96] || (_cache[96] = ($event: any) => ((_ctx.medlemData.medlemBy) = $event)),
                                    onFocus: _cache[97] || (_cache[97] = ($event: any) => (_ctx.medlemByPostnummerInputFocus = 1)),
                                    type: "text",
                                    label: "By",
                                    placeholder: "By"
                                  }, null, 8, ["modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_137, [
                                _createElementVNode("div", _hoisted_138, [
                                  _createVNode(_component_va_select, {
                                    label: "Klubrolle",
                                    modelValue: _ctx.clubRoleStringValue,
                                    "onUpdate:modelValue": _cache[98] || (_cache[98] = ($event: any) => ((_ctx.clubRoleStringValue) = $event)),
                                    options: _ctx.clubRoleStringOptions,
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options"])
                                ])
                              ]),
                              _createElementVNode("div", null, _toDisplayString(_ctx.languageValue === 1 ? 'Bemærk: Ved at vælge avanceret medlemskab vil du kunne deltage i flere klubber.' : 'Note: By selecting advance membership you will be able to participate in multiple clubs'), 1),
                              _createElementVNode("div", _hoisted_139, [
                                _createElementVNode("div", _hoisted_140, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedMembershipOptions, (MembershipPlanOption, index) => {
                                    return (_openBlock(), _createBlock(_component_va_radio, {
                                      key: index,
                                      modelValue: _ctx.selectedMembership,
                                      "onUpdate:modelValue": _cache[99] || (_cache[99] = ($event: any) => ((_ctx.selectedMembership) = $event)),
                                      option: MembershipPlanOption,
                                      label: _ctx.competitionPlayerModusLabels[index]
                                    }, null, 8, ["modelValue", "option", "label"]))
                                  }), 128))
                                ]),
                                _createElementVNode("div", _hoisted_141, [
                                  _createVNode(_component_va_select, {
                                    label: "Medlem af",
                                    modelValue: _ctx.clubStringValue,
                                    "onUpdate:modelValue": _cache[100] || (_cache[100] = ($event: any) => ((_ctx.clubStringValue) = $event)),
                                    multiple: _ctx.selectedMembership === '1' ? true : false,
                                    disabled: !_ctx.selectedMembership,
                                    options: _ctx.clubStringOptions,
                                    "text-by": (clubStringOptions) => clubStringOptions.name,
                                    bordered: "",
                                    searchable: ""
                                  }, null, 8, ["modelValue", "multiple", "disabled", "options", "text-by"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_142, [
                                _createElementVNode("div", _hoisted_143, [
                                  _createVNode(_component_va_select, {
                                    label: "Angiv brugerrettigheder",
                                    modelValue: _ctx.userGroupStringValue,
                                    "onUpdate:modelValue": _cache[101] || (_cache[101] = ($event: any) => ((_ctx.userGroupStringValue) = $event)),
                                    options: _ctx.userGroupStringOptions,
                                    "text-by": (userGroupStringOptions) => userGroupStringOptions.name,
                                    "track-by": (userGroupStringOptions) => userGroupStringOptions.id,
                                    bordered: "",
                                    searchable: ""
                                  }, null, 8, ["modelValue", "options", "text-by", "track-by"])
                                ]),
                                _createElementVNode("div", _hoisted_144, [
                                  _createVNode(_component_va_select, {
                                    label: "Dele oplysninger",
                                    modelValue: _ctx.sharePermissionsValue,
                                    "onUpdate:modelValue": _cache[102] || (_cache[102] = ($event: any) => ((_ctx.sharePermissionsValue) = $event)),
                                    options: _ctx.sharePermissionsOptions,
                                    bordered: ""
                                  }, null, 8, ["modelValue", "options"])
                                ]),
                                _createElementVNode("div", _hoisted_145, [
                                  _createVNode(_component_va_checkbox, {
                                    label: "Opret med betalt licens",
                                    modelValue: _ctx.createMemberWithLicense,
                                    "onUpdate:modelValue": _cache[103] || (_cache[103] = ($event: any) => ((_ctx.createMemberWithLicense) = $event))
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _createElementVNode("div", _hoisted_146, [
                        _createElementVNode("div", _hoisted_147, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[104] || (_cache[104] = ($event: any) => {_ctx.$refs.form.validate(); _ctx.createMember()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_148
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret nyt medlem']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_149, [
        _createElementVNode("div", _hoisted_150, [
          _createElementVNode("div", _hoisted_151, [
            _createVNode(_component_va_popover, {
              color: "primary",
              message: "Nulstil kolonner"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_button, {
                  class: "btn",
                  rounded: false,
                  onClick: _cache[105] || (_cache[105] = ($event: any) => (_ctx.columnSortForeign('reset')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_va_icon, {
                      class: "reset",
                      name: "autorenew"
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_152, [
            _createVNode(_component_va_input, {
              modelValue: _ctx.foreignSearchInputValue,
              "onUpdate:modelValue": _cache[106] || (_cache[106] = ($event: any) => ((_ctx.foreignSearchInputValue) = $event)),
              label: "Søg",
              onKeyup: _cache[107] || (_cache[107] = _withKeys(($event: any) => (_ctx.findForeign()), ["enter"]))
            }, {
              prependInner: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "person_search" })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_va_button, {
              size: "small",
              class: "btn ml-2",
              rounded: false,
              onClick: _cache[108] || (_cache[108] = ($event: any) => (_ctx.findForeign()))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_va_icon, { name: "search" }),
                _hoisted_153
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_154, [
          _hoisted_155,
          _createElementVNode("div", _hoisted_156, [
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnNameForeign,
              "onUpdate:modelValue": _cache[109] || (_cache[109] = ($event: any) => ((_ctx.columnNameForeign) = $event)),
              "array-value": "name",
              label: "Navn"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnNameForeign,
              "onUpdate:modelValue": _cache[110] || (_cache[110] = ($event: any) => ((_ctx.columnNameForeign) = $event)),
              "array-value": "birthdata",
              label: "Fødselsdag"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnNameForeign,
              "onUpdate:modelValue": _cache[111] || (_cache[111] = ($event: any) => ((_ctx.columnNameForeign) = $event)),
              "array-value": "gender",
              label: "Køn"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnNameForeign,
              "onUpdate:modelValue": _cache[112] || (_cache[112] = ($event: any) => ((_ctx.columnNameForeign) = $event)),
              "array-value": "country",
              label: "Nationalitet"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnNameForeign,
              "onUpdate:modelValue": _cache[113] || (_cache[113] = ($event: any) => ((_ctx.columnNameForeign) = $event)),
              "array-value": "paradart",
              label: "Paradart"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnNameForeign,
              "onUpdate:modelValue": _cache[114] || (_cache[114] = ($event: any) => ((_ctx.columnNameForeign) = $event)),
              "array-value": "email",
              label: "Email"
            }, null, 8, ["modelValue"]),
            _createVNode(_component_va_checkbox, {
              modelValue: _ctx.columnNameForeign,
              "onUpdate:modelValue": _cache[115] || (_cache[115] = ($event: any) => ((_ctx.columnNameForeign) = $event)),
              "array-value": "created",
              label: "Oprettet"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createVNode(_component_it_divider),
        (_ctx.error)
          ? (_openBlock(), _createElementBlock("div", _hoisted_157, _toDisplayString(_ctx.error), 1))
          : (_openBlock(), _createElementBlock("div", _hoisted_158, [
              _createElementVNode("table", _hoisted_159, [
                _createElementVNode("thead", null, [
                  _createElementVNode("tr", null, [
                    _hoisted_160,
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[116] || (_cache[116] = ($event: any) => (_ctx.columnSortForeign('navn')))
                    }, "Navn", 512), [
                      [_vShow, _ctx.showColumnForeign('name')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[117] || (_cache[117] = ($event: any) => (_ctx.columnSortForeign('foedselsdag')))
                    }, "Fødselsdag", 512), [
                      [_vShow, _ctx.showColumnForeign('birthdate')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[118] || (_cache[118] = ($event: any) => (_ctx.columnSortForeign('koen')))
                    }, "Køn", 512), [
                      [_vShow, _ctx.showColumnForeign('gender')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[119] || (_cache[119] = ($event: any) => (_ctx.columnSortForeign('land')))
                    }, "Nationalitet", 512), [
                      [_vShow, _ctx.showColumnForeign('country')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting center",
                      onClick: _cache[120] || (_cache[120] = ($event: any) => (_ctx.columnSortForeign('paradart')))
                    }, "Paradart", 512), [
                      [_vShow, _ctx.showColumnForeign('paradart')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[121] || (_cache[121] = ($event: any) => (_ctx.columnSortForeign('email')))
                    }, "Email", 512), [
                      [_vShow, _ctx.showColumnForeign('email')]
                    ]),
                    _withDirectives(_createElementVNode("th", {
                      class: "sorting",
                      onClick: _cache[122] || (_cache[122] = ($event: any) => (_ctx.columnSortForeign('oprettet')))
                    }, "Oprettet", 512), [
                      [_vShow, _ctx.showColumnForeign('created')]
                    ]),
                    _hoisted_161
                  ])
                ]),
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.foreignPlayers, (player, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: player.id
                    }, [
                      _createElementVNode("td", {
                        id: 'foreignPlayersTable-row' + (index+1),
                        hidden: ""
                      }, _toDisplayString(player.id), 9, _hoisted_162),
                      _withDirectives(_createElementVNode("td", {
                        id: 'foreignPlayersTable-row' + (index+1)
                      }, _toDisplayString(player.ud_spiller_fornavn +' ' + player.ud_spiller_efternavn), 9, _hoisted_163), [
                        [_vShow, _ctx.showColumnForeign('name')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'foreignPlayersTable-row' + (index+1)
                      }, _toDisplayString(_ctx.toDanishDateString(player.ud_foedselsdag)), 9, _hoisted_164), [
                        [_vShow, _ctx.showColumnForeign('birthdate')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'foreignPlayersTable-row' + (index+1)
                      }, _toDisplayString(player?.koen_id?.Koen), 9, _hoisted_165), [
                        [_vShow, _ctx.showColumnForeign('gender')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'foreignPlayersTable-row' + (index+1)
                      }, _toDisplayString(player.ud_spiller_land), 9, _hoisted_166), [
                        [_vShow, _ctx.showColumnForeign('country')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'foreignPlayersTable-row' + (index+1),
                        class: "center"
                      }, [
                        _createVNode(_component_va_icon, {
                          name: player.ud_spiller_paradart ? 'done' : '',
                          color: player.ud_spiller_paradart ? 'success' : ''
                        }, null, 8, ["name", "color"])
                      ], 8, _hoisted_167), [
                        [_vShow, _ctx.showColumnForeign('paradart')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'foreignPlayersTable-row' + (index+1)
                      }, _toDisplayString((player.ud_spiller_mail === null ? 'Ingen' : player.ud_spiller_mail)), 9, _hoisted_168), [
                        [_vShow, _ctx.showColumnForeign('email')]
                      ]),
                      _withDirectives(_createElementVNode("td", {
                        id: 'foreignPlayersTable-row' + (index+1)
                      }, _toDisplayString(_ctx.toDanishDateString(player.createdAt)), 9, _hoisted_169), [
                        [_vShow, _ctx.showColumnForeign('created')]
                      ]),
                      _createElementVNode("td", {
                        id: 'foreignPlayersTable-row' + (index+1)
                      }, [
                        _createVNode(_component_va_button_group, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_va_button, {
                              class: "btn",
                              color: "info",
                              rounded: false,
                              name: "editforeignplayer",
                              onClick: ($event: any) => (_ctx.editForeignPlayer(player.documentId))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_171
                              ]),
                              _: 2
                            }, 1032, ["onClick"]),
                            _createVNode(_component_va_button, {
                              class: "btn",
                              color: "danger",
                              rounded: false,
                              name: "deleteforeignplayer",
                              onClick: ($event: any) => (_ctx.deleteForeignPlayerWarning(player.documentId, player.ud_spiller_navn))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_172
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024)
                      ], 8, _hoisted_170)
                    ]))
                  }), 128))
                ])
              ])
            ])),
        _createElementVNode("div", _hoisted_173, [
          _createVNode(_component_va_button, {
            icon: "first_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[123] || (_cache[123] = ($event: any) => (_ctx.jumpToPageForeign(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[124] || (_cache[124] = ($event: any) => (_ctx.turnToNewPageForeign(-5)))
          }),
          _createVNode(_component_va_button, {
            icon: "chevron_left",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[125] || (_cache[125] = ($event: any) => (_ctx.turnToNewPageForeign(-1)))
          }),
          _hoisted_174,
          _withDirectives(_createElementVNode("input", {
            "onUpdate:modelValue": _cache[126] || (_cache[126] = ($event: any) => ((_ctx.currentPageForeign) = $event)),
            type: "number",
            onKeyup: _cache[127] || (_cache[127] = _withKeys(($event: any) => (_ctx.jumpToPageForeign(this.currentPageForeign)), ["enter"]))
          }, null, 544), [
            [_vModelText, _ctx.currentPageForeign]
          ]),
          (_ctx.totalNumberOfPagesForeign === 0)
            ? (_openBlock(), _createElementBlock("p", _hoisted_175, " af " + _toDisplayString(_ctx.totalNumberOfPagesForeign+1), 1))
            : (_openBlock(), _createElementBlock("p", _hoisted_176, " af " + _toDisplayString(_ctx.totalNumberOfPagesForeign), 1)),
          _createVNode(_component_va_button, {
            icon: "chevron_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[128] || (_cache[128] = ($event: any) => (_ctx.turnToNewPageForeign(1)))
          }),
          _createVNode(_component_va_button, {
            icon: "keyboard_double_arrow_right",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[129] || (_cache[129] = ($event: any) => (_ctx.turnToNewPageForeign(5)))
          }),
          _createVNode(_component_va_button, {
            icon: "last_page",
            class: "mr-2",
            size: "small",
            rounded: false,
            onClick: _cache[130] || (_cache[130] = ($event: any) => (_ctx.jumpToPageForeign(this.totalNumberOfPageForeign)))
          }),
          _hoisted_177,
          _createElementVNode("div", _hoisted_178, [
            _createVNode(_component_va_select, {
              class: "mr-2",
              modelValue: _ctx.pageSizeValueStringForeign,
              "onUpdate:modelValue": _cache[131] || (_cache[131] = ($event: any) => ((_ctx.pageSizeValueStringForeign) = $event)),
              options: _ctx.pageSizeOptionsForeign,
              bordered: ""
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.deleteForeignPlayerWarningModal,
          "onUpdate:modelValue": _cache[134] || (_cache[134] = ($event: any) => ((_ctx.deleteForeignPlayerWarningModal) = $event)),
          "hide-default-actions": "",
          "overlay-opacity": "0.5"
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "deletebuttonmargin btn",
              color: "danger",
              onClick: _cache[132] || (_cache[132] = ($event: any) => (_ctx.deleteForeignPlayer(this.deleteForeignPlayerId), _ctx.$Message.success({ text: 'Spilleren er blevet slettet' })))
            }, {
              default: _withCtx(() => [
                _hoisted_186
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "deletebuttonmargin btn",
              color: "secondary",
              onClick: _cache[133] || (_cache[133] = ($event: any) => (_ctx.deleteForeignPlayerWarningModal = false, _ctx.$Message.warning({ text: 'Annulleret' })))
            }, {
              default: _withCtx(() => [
                _hoisted_187
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_179, [
              _createElementVNode("div", _hoisted_180, [
                _createElementVNode("div", _hoisted_181, [
                  _createElementVNode("p", _hoisted_182, [
                    _hoisted_183,
                    _createElementVNode("strong", null, _toDisplayString(this.deleteForeignPlayerName), 1),
                    _hoisted_184
                  ])
                ])
              ]),
              _hoisted_185
            ])
          ]),
          _: 1
        }, 8, ["modelValue"]),
        _createVNode(_component_va_modal, {
          modelValue: _ctx.editForeignPlayerModal,
          "onUpdate:modelValue": _cache[144] || (_cache[144] = ($event: any) => ((_ctx.editForeignPlayerModal) = $event)),
          size: "large",
          "hide-default-actions": "",
          "overlay-opacity": "0.5",
          "no-dismiss": ""
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "success",
              onClick: _cache[142] || (_cache[142] = ($event: any) => (_ctx.updateForeignPlayer() ? _ctx.$Message.success({ text: 'Spiller opdateret' }) : _ctx.$Message.danger({ text: 'Fejl i et felts værdi' })))
            }, {
              default: _withCtx(() => [
                _hoisted_205
              ]),
              _: 1
            }),
            _createVNode(_component_va_button, {
              class: "btn mr-4",
              color: "secondary",
              onClick: _cache[143] || (_cache[143] = ($event: any) => (_ctx.cancelForeignPlayerEdit(), _ctx.$Message.warning({ text: 'Annulleret'})))
            }, {
              default: _withCtx(() => [
                _hoisted_206
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_188, [
              _createElementVNode("div", _hoisted_189, [
                _createElementVNode("div", _hoisted_190, [
                  _createElementVNode("h6", _hoisted_191, [
                    _hoisted_192,
                    _createElementVNode("u", null, _toDisplayString(_ctx.foreignPlayerData.foreignPlayerName), 1)
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_193, [
                _createElementVNode("div", _hoisted_194, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.foreignPlayerData.foreignPlayerFirstName,
                    "onUpdate:modelValue": _cache[135] || (_cache[135] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerFirstName) = $event)),
                    label: "Fornavn",
                    placeholder: "Fornavn",
                    bordered: "",
                    rules: [(foreignPlayerFirstName) => _ctx.foreignPlayerData.foreignPlayerFirstName.length > 1 || 'Der mangler et fornavn']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_195, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.foreignPlayerData.foreignPlayerLastName,
                    "onUpdate:modelValue": _cache[136] || (_cache[136] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerLastName) = $event)),
                    label: "Efternavn",
                    placeholder: "Efternavn",
                    bordered: "",
                    rules: [(foreignPlayerLastName) => _ctx.foreignPlayerData.foreignPlayerLastName.length > 1 || 'Der mangler et efternavn']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_196, [
                  _createVNode(_component_va_select, {
                    modelValue: _ctx.foreignPlayerData.foreignPlayerCountry,
                    "onUpdate:modelValue": _cache[137] || (_cache[137] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerCountry) = $event)),
                    label: "Nationalitet",
                    options: _ctx.countryListOptions,
                    "track-by": _ctx.index,
                    searchable: "",
                    bordered: "",
                    rules: [(foreignPlayerCountry) => _ctx.foreignPlayerData.foreignPlayerCountry.length > 0 || 'Angiv en nationalitet']
                  }, null, 8, ["modelValue", "options", "track-by", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_197, [
                _createElementVNode("div", _hoisted_198, [
                  _createVNode(_component_va_input, {
                    type: "text",
                    modelValue: _ctx.foreignPlayerData.foreignPlayerMail,
                    "onUpdate:modelValue": _cache[138] || (_cache[138] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerMail) = $event)),
                    label: "Email",
                    bordered: "",
                    rules: [(foreignPlayerMail) => _ctx.foreignPlayerData.foreignPlayerMail.length > 2 && _ctx.foreignPlayerData.foreignPlayerMail.includes('@') || 'Email mangler']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_199, [
                  _createVNode(_component_va_input, {
                    class: "center",
                    type: "date",
                    modelValue: _ctx.foreignPlayerData.foreignPlayerBirthdate,
                    "onUpdate:modelValue": _cache[139] || (_cache[139] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerBirthdate) = $event)),
                    label: "Fødselsdag",
                    placeholder: "Dato",
                    bordered: "",
                    rules: [(foreignPlayerBirthdate) => _ctx.foreignPlayerData.foreignPlayerBirthdate !== '' || 'Fødselsdag er ikke angivet']
                  }, null, 8, ["modelValue", "rules"])
                ]),
                _createElementVNode("div", _hoisted_200, [
                  _createVNode(_component_va_select, {
                    modelValue: _ctx.foreignPlayerData.foreignPlayerGender,
                    "onUpdate:modelValue": _cache[140] || (_cache[140] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerGender) = $event)),
                    label: "Køn",
                    bordered: "",
                    options: _ctx.koenStringOptions,
                    rules: [(foreignPlayerGender) => _ctx.foreignPlayerData.foreignPlayerGender !== 'Vælg her' || 'Angiv køn' ]
                  }, null, 8, ["modelValue", "options", "rules"])
                ])
              ]),
              _createElementVNode("div", _hoisted_201, [
                _createElementVNode("div", _hoisted_202, [
                  _createVNode(_component_va_checkbox, {
                    modelValue: _ctx.foreignPlayerData.foreignPlayerParadart,
                    "onUpdate:modelValue": _cache[141] || (_cache[141] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerParadart) = $event)),
                    label: "Paradartspiller",
                    bordered: ""
                  }, null, 8, ["modelValue"])
                ]),
                _createElementVNode("div", _hoisted_203, [
                  _createElementVNode("p", null, [
                    _createElementVNode("i", null, "Oprettet: " + _toDisplayString(_ctx.toDanishDateString(_ctx.foreignPlayerData.foreignPlayerCreated)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_204, [
                  _createElementVNode("p", null, [
                    _createElementVNode("i", null, "Sidst opdateret: " + _toDisplayString(_ctx.toDanishDateString(_ctx.foreignPlayerData.foreignPlayerUpdated)), 1)
                  ])
                ])
              ])
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Vis og rediger udenlandske spillere']
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_207, [
        _createElementVNode("div", _hoisted_208, [
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_209, _toDisplayString(_ctx.error), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_210, [
                (!_ctx.submitted)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_211, [
                      _createElementVNode("div", _hoisted_212, [
                        _createVNode(_component_va_form, {
                          ref: "form",
                          id: "newforeignplayerform"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_213, [
                              _createElementVNode("div", _hoisted_214, [
                                _createElementVNode("div", _hoisted_215, [
                                  _createVNode(_component_va_input, {
                                    type: "text",
                                    modelValue: _ctx.foreignPlayerData.foreignPlayerFirstName,
                                    "onUpdate:modelValue": _cache[145] || (_cache[145] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerFirstName) = $event)),
                                    label: "Fornavn",
                                    rules: [(foreignPlayerFirstName) => _ctx.foreignPlayerData.foreignPlayerFirstName.length > 1 || 'Der mangler et fornavn'],
                                    placeholder: "Navn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_216, [
                                  _createVNode(_component_va_input, {
                                    type: "text",
                                    modelValue: _ctx.foreignPlayerData.foreignPlayerLastName,
                                    "onUpdate:modelValue": _cache[146] || (_cache[146] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerLastName) = $event)),
                                    label: "Efternavn",
                                    ruler: [(foreignPlayerLastName) => _ctx.foreignPlayerData.foreignPlayerLastName.length > 1 || 'Der mangler et efternavn'],
                                    placerholder: "Navn",
                                    bordered: ""
                                  }, null, 8, ["modelValue", "ruler"])
                                ]),
                                _createElementVNode("div", _hoisted_217, [
                                  _createVNode(_component_va_select, {
                                    modelValue: _ctx.countryStringValue,
                                    "onUpdate:modelValue": _cache[147] || (_cache[147] = ($event: any) => ((_ctx.countryStringValue) = $event)),
                                    label: "Nationalitet",
                                    options: _ctx.countryListOptions,
                                    searchable: "",
                                    bordered: "",
                                    rules: [(countryStringValue) => countryStringValue !== 'Vælg her' || 'Angiv en nationalitet' ]
                                  }, null, 8, ["modelValue", "options", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_218, [
                                _createElementVNode("div", _hoisted_219, [
                                  _createVNode(_component_va_input, {
                                    type: "text",
                                    modelValue: _ctx.foreignPlayerData.foreignPlayerMail,
                                    "onUpdate:modelValue": _cache[148] || (_cache[148] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerMail) = $event)),
                                    label: "Email",
                                    bordered: "",
                                    rules: [(foreignPlayerMail) => _ctx.foreignPlayerData.foreignPlayerMail.length > 2 && _ctx.foreignPlayerData.foreignPlayerMail.includes('@') || 'Email mangler'],
                                    placeholder: "mailuser@domain.tld"
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_220, [
                                  _createVNode(_component_va_input, {
                                    class: "center",
                                    type: "date",
                                    modelValue: _ctx.foreignPlayerData.foreignPlayerBirthdate,
                                    "onUpdate:modelValue": _cache[149] || (_cache[149] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerBirthdate) = $event)),
                                    label: "Fødselsdag",
                                    placeholder: "Dato",
                                    rules: [(foreignPlayerBirthdate) => _ctx.foreignPlayerData.foreignPlayerBirthdate !== '' || 'Der mangler en fødselsdagsdato'],
                                    bordered: ""
                                  }, null, 8, ["modelValue", "rules"])
                                ]),
                                _createElementVNode("div", _hoisted_221, [
                                  _createVNode(_component_va_select, {
                                    modelValue: _ctx.koenStringValueForeign,
                                    "onUpdate:modelValue": _cache[150] || (_cache[150] = ($event: any) => ((_ctx.koenStringValueForeign) = $event)),
                                    label: "Køn",
                                    bordered: "",
                                    options: _ctx.koenStringOptions,
                                    rules: [(koenStringValueForeign) => koenStringValueForeign !== 'Vælg her' || 'Angiv køn']
                                  }, null, 8, ["modelValue", "options", "rules"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_222, [
                                _createElementVNode("div", _hoisted_223, [
                                  _createVNode(_component_va_checkbox, {
                                    modelValue: _ctx.foreignPlayerData.foreignPlayerParadart,
                                    "onUpdate:modelValue": _cache[151] || (_cache[151] = ($event: any) => ((_ctx.foreignPlayerData.foreignPlayerParadart) = $event)),
                                    label: "Paradartspiller",
                                    bordered: ""
                                  }, null, 8, ["modelValue"])
                                ])
                              ])
                            ])
                          ]),
                          _: 1
                        }, 512)
                      ]),
                      _createElementVNode("div", _hoisted_224, [
                        _createElementVNode("div", _hoisted_225, [
                          _createVNode(_component_va_button, {
                            class: "btn",
                            color: "success",
                            size: "large",
                            onClick: _cache[152] || (_cache[152] = ($event: any) => {_ctx.$refs.form.validate();_ctx.createForeignPlayer()})
                          }, {
                            default: _withCtx(() => [
                              _hoisted_226
                            ]),
                            _: 1
                          })
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ]))
        ])
      ], 512), [
        [_vShow, _ctx.tabValue === 'Opret ny udenlandsk spiller']
      ])
    ])
  ]))
}